import { useEffect, useMemo } from 'react';

import { PageContainer } from 'components';
import { useLazyGetCandidateFamilySessionsQuery } from 'store/my-registrations/myRegistrationsAPI';

import { MainContainer } from '@britishcouncil/react-solas-ors3';

import { useMyRegistrationsData } from '../my-registrations/useMyRegistrationsData';

import { CandidateReport } from './components/CandidateReport';

export const MyRegistrationsSummary = () => {
  const { isLoading, data: summary } = useMyRegistrationsData();

  const [getCandidateFamilySessions, { data: familySessions, isFetching: familySessionsLoading }] =
    useLazyGetCandidateFamilySessionsQuery();

  const candidates = useMemo(
    () =>
      summary
        ? [summary?.candidate, ...(summary?.childCandidates ?? [])].map((candidate) => ({
            ...candidate,
            sessions: familySessions?.find((x) => x.candidateId === candidate.id)?.sessions ?? [],
          }))
        : [],
    [summary, familySessions]
  );

  useEffect(() => {
    if (summary?.candidate) {
      getCandidateFamilySessions(summary.candidate.id);
    }
  }, [getCandidateFamilySessions, summary]);

  return (
    <>
      <MainContainer>
        <h1>Registration Summary</h1>
      </MainContainer>
      <PageContainer loading={isLoading}>
        {candidates.map((candidate, i) => (
          <CandidateReport candidate={candidate} loading={familySessionsLoading} key={i} />
        ))}
      </PageContainer>
    </>
  );
};
